var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down",style:({color: _vm.color,fontSize: _vm.fontSize,fontStyle:_vm.italic?'italic':'normal'})},[_vm._v(_vm._s(_vm.beforeTimeContent)),(_vm.day>0)?_c('span',[_vm._v(_vm._s(_vm.day+'天'))]):_vm._e(),_vm._v(" "+_vm._s(_vm.hour)+":"+_vm._s(_vm.minute)+":"+_vm._s(_vm.second))])
}
var staticRenderFns = []

export { render, staticRenderFns }